import { cn } from "@/lib/utils";

export function MinusIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.288 10.94v1.536h-8.56V10.94h8.56z" fill="currentColor" />
    </svg>
  );
}

export function PlusIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.081 12.492H12.85v3.312h-1.696v-3.312H7.921v-1.536h3.232V7.644h1.696v3.312h3.232v1.536z"
        fill="currentColor"
      />
    </svg>
  );
}
